// DESTINATIONS

// ROUTE MAP
const locationIds = {
    palma: 30,
    alicante: 16,
    murcia: 28,
    malaga: 26,
    faro: 20,
    tenerife: 36,
    'gran-canaria': 22,
    barcelona: 18,
    pisa: 32,
    lanzarote: 24,
    prestwick: 0,
};

const updateLocation = async (loc) => {
    let newData = await fetch();
    return newData;
};

let routeMap = document.querySelectorAll('.component__route-map');
routeMap.forEach((element) => {
    let id = element.id;
    let inner = element.querySelector('.inner');
    let locations = element.querySelectorAll('.route-map-svg .location');
    locations.forEach((location, index) => {
        location.addEventListener('click', () => {
            element.classList.add('loading');

            locations.forEach((l) => {
                l.classList.remove('active');
            });
            location.classList.add('active');

            let loc = location.id;

            let formData = new FormData();
            formData.append('action', 'pa_update_route_map');
            formData.append('location', locationIds[loc]);

            fetch(pajax.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                body: formData,
            })
                .then((response) => response.json())
                .then((data) => {
                    inner.innerHTML = data.data.content;
                    element.classList.remove('loading');
                })
                .catch((error) => {
                    console.error(error);
                });
        });
    });
});
